import { firstOfMonth, lastOfMonth } from '@krp/ui-kit'

import type { ReceiptsFilter, ReceiptSummary } from './types'

/** Месячный срез покрывает даты, но не поиск по номеру и не смену через полночь. */
export function summaryUsesMonth(filter: ReceiptsFilter): boolean {
  return filter.shiftNumber === '' && filter.search === '' && filter.dateFrom !== '' && filter.dateTo >= filter.dateFrom
    && filter.dateTo <= lastOfMonth(filter.dateFrom)
}

/** Итоги выбранных дней из месячного кэша; список чеков для этого не нужен. */
export function summaryRangeOf(data: ReceiptSummary, filter: ReceiptsFilter): ReceiptSummary {
  if (filter.dateFrom === firstOfMonth(filter.dateFrom) && filter.dateTo === lastOfMonth(filter.dateFrom)) return data
  const days = data.days.filter((day) => day.day >= filter.dateFrom && day.day <= filter.dateTo)
  const sum = (field: keyof Omit<ReceiptSummary['days'][number], 'day'>) => days.reduce((total, day) => total + (day[field] ?? 0), 0)
  return { ...data, days, saleCount: sum('saleCount'), saleKopecks: sum('saleKopecks'),
    saleCashKopecks: sum('saleCashKopecks'), saleCashlessKopecks: sum('saleCashlessKopecks'),
    refundCount: sum('refundCount'), refundKopecks: sum('refundKopecks'),
    refundCashKopecks: sum('refundCashKopecks'), refundCashlessKopecks: sum('refundCashlessKopecks') }
}
